// reactstrap components
import {
  Container,
  Row,
} from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import Platforms from "../../../components/Platforms.js";

const DemographicView = () => {
  return (
    <>
      <Header 
        title="Platforms"
        description="Platforms Used"
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Platforms />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default DemographicView;